"use client";

import { useRouter } from "next/navigation";
import queryString from "query-string";
import { useForm } from "react-hook-form";

import { normalizeTnsName } from "@coinbot/forge-api/external";

import { SearchInput } from "~/components/common/SearchInput";
import { Button } from "~/components/ui";

type FormValues = {
  search: string;
};

export const SearchCTASection = () => {
  const router = useRouter();

  const form = useForm<FormValues>({
    defaultValues: {
      search: "",
    },
  });

  const onSubmit = ({ search }: FormValues) => {
    const newSearchParams = queryString.stringify({ contains: normalizeTnsName(search) });

    router.push(`/market?${newSearchParams}`);
  };

  return (
    <div className="-mx-7 mt-6 flex flex-col justify-center bg-[url('/bg-forge-mobile.svg')] bg-cover bg-center bg-no-repeat px-8 pb-36 pt-16 md:mx-0 md:px-0 md:py-40">
      <svg width="0" height="0">
        <filter id="f" x="-50%" y="-200%" width="200%" height="500%">
          <feGaussianBlur stdDeviation="15"></feGaussianBlur>
          <feColorMatrix type="saturate" values="1.2"></feColorMatrix>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </svg>

      <h2 className="gradient-text-glow text-balance text-center text-4xl font-bold uppercase leading-tight md:text-6xl md:font-medium">
        Forge your
        <br />
        thor identity now
      </h2>

      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="mx-auto mt-12 flex w-full max-w-[560px] space-x-4 md:space-x-12">
          <SearchInput
            className="w-full !bg-black/30"
            {...form.register("search")}
            value={form?.watch("search")?.toLowerCase()}
          />

          <Button className="h-11 !w-[100px] min-w-0 text-[19px] font-bold">Go</Button>
        </div>
      </form>
    </div>
  );
};
